import React from "react";

export function SourceText(props) {
    return <li className="text-sm mb-2">{props.text}</li>;
}